import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";

// (26/10/2026) TẮT xuất Excel kết quả chấm cả phòng (điểm thi khảo sát). Bật lại: đặt true.
const SCAN_EXCEL_EXPORT = false;
import { uploadScanBatch, scanBatchPage, deleteScanBatch, scanBatchPageImage } from "./quiz3Utils";
import { parseAnswerKey, gradeSheet } from "./thpt3Grade";
import { getActiveSchoolId } from "../happyschool_static/activeSchool";
import { getHsToken } from "../happyschool_static/hsAuth";
import { listThiKhaoSat, getThiKhaoSat, saveAnswerKeyThiKhaoSat, saveScoresBySbdThiKhaoSat, saveSheetsThiKhaoSat, uploadThiKhaoSatFile } from "../happyschool_static/happyschoolApi";

// Chấm CẢ PHÒNG: chọn 1 hoặc nhiều file PDF scan phiếu trả lời THPT 3 phần
// (mỗi trang 1 phiếu, thường mỗi phòng 1 file) -> máy chủ đọc lần lượt từng
// trang -> bảng SBD / Mã đề / Phần I / II / III + cảnh báo -> xuất Excel.
// Nếu tải thêm file đáp án Excel (mẫu Dap_an_excel_app_QM_2025.xlsx: mỗi hàng 1 mã đề)
// thì tính điểm theo thang Bộ 2025 (xem thpt3Grade.js) — tính ngay trên trình duyệt.

const fmtP1 = (arr) =>
  (arr || []).map((v) => (v == null ? "·" : v === "multi" ? "*" : v)).join("").replace(/·+$/, "").replace(/(.{10})/g, "$1 ").trim();
const ds = (v) => (v === true ? "Đ" : v === false ? "S" : v === "multi" ? "*" : "·");
const fmtP2 = (arr) =>
  (arr || [])
    .map((q, i) => (q && [q.a, q.b, q.c, q.d].some((v) => v != null) ? `${i + 1}:${ds(q.a)}${ds(q.b)}${ds(q.c)}${ds(q.d)}` : null))
    .filter(Boolean)
    .join(" ");
const fmtP3 = (arr) =>
  (arr || []).map((v, i) => (v == null ? null : `${i + 1}:${v}`)).filter(Boolean).join("  ");

function downloadWorkbook(wb, fileName) {
  const wbArray = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const Quiz3ScanBatch = () => {
  const [files, setFiles] = useState([]);
  const [rows, setRows] = useState([]); // { file, page, ...result }
  const [running, setRunning] = useState(false);
  const [progress, setProgress] = useState({ done: 0, total: 0, label: "" });
  const [error, setError] = useState("");
  const [onlyWarn, setOnlyWarn] = useState(false);
  const stopRef = useRef(false);
  const batchIdsRef = useRef([]); // file đã tải lên máy chủ quét — giữ lại (tối đa 3 giờ) để lấy ảnh bài làm khi đẩy điểm
  const clearBatches = () => { batchIdsRef.current.forEach((id) => deleteScanBatch(id)); batchIdsRef.current = []; };
  useEffect(() => () => clearBatches(), []); // eslint-disable-line
  const [keys, setKeys] = useState(null); // { [maDe]: {p1,p2,p3} }
  const [keyName, setKeyName] = useState("");
  const [keyError, setKeyError] = useState("");

  const loadKey = async (f) => {
    setKeyError("");
    setKeys(null);
    setKeyName("");
    if (!f) return;
    try {
      const wb = XLSX.read(await f.arrayBuffer(), { type: "array" });
      const k = parseAnswerKey(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1, raw: false }));
      setKeys(k);
      setKeyName(`${f.name} — ${Object.keys(k).length} mã đề`);
    } catch (e) {
      setKeyError(e.message);
    }
  };
  const gradeOf = (r) => (keys && r.ok ? gradeSheet(r, keys) : null);

  // ---- Gắn với kỳ "Thi khảo sát" HappySchool: lưu / dùng lại đáp án, đẩy điểm theo SBD ----
  const schoolId = getActiveSchoolId();
  const canHs = !!(schoolId && getHsToken());
  const [ksList, setKsList] = useState([]);
  const [ksId, setKsId] = useState("");
  const [ksExam, setKsExam] = useState(null); // { exam, subjects }
  const [ksSubj, setKsSubj] = useState("toan");
  const [ksMsg, setKsMsg] = useState({ ok: "", err: "" });
  const [ksBusy, setKsBusy] = useState(false);
  useEffect(() => {
    if (!canHs) return;
    listThiKhaoSat(schoolId).then((l) => { setKsList(l || []); if (l && l.length) setKsId(l[0].id); }).catch(() => {});
  }, [canHs, schoolId]);
  useEffect(() => {
    setKsExam(null);
    if (!canHs || !ksId) return;
    getThiKhaoSat(schoolId, ksId).then((d) => setKsExam({ exam: d.exam || {}, subjects: d.subjects || [] })).catch((e) => setKsMsg({ ok: "", err: e.message }));
  }, [canHs, schoolId, ksId]);
  const savedKey = ksExam && ((ksExam.exam.answerKeys || {})[ksSubj] || null);
  const ksAct = async (fn) => {
    setKsBusy(true); setKsMsg({ ok: "", err: "" });
    try { setKsMsg({ ok: await fn(), err: "" }); } catch (e) { setKsMsg({ ok: "", err: e.message }); } finally { setKsBusy(false); }
  };
  const useSavedKey = () => {
    if (!savedKey) return;
    setKeys(savedKey.keys); setKeyError("");
    setKeyName(`${savedKey.fileName || "đáp án đã lưu"} (lưu trên kỳ thi) — ${Object.keys(savedKey.keys || {}).length} mã đề`);
  };
  const saveKeyToExam = () => ksAct(async () => {
    const fileName = keyName.replace(/ — \d+ mã đề$/, "");
    await saveAnswerKeyThiKhaoSat(schoolId, ksId, { subjectKey: ksSubj, fileName, keys });
    const d = await getThiKhaoSat(schoolId, ksId); setKsExam({ exam: d.exam || {}, subjects: d.subjects || [] });
    return `Đã lưu đáp án (${Object.keys(keys).length} mã đề) lên kỳ thi.`;
  });
  const pushScores = () => ksAct(async () => {
    const scores = {}; const notes = {}; const dup = [];
    rows.forEach((r) => {
      const g = gradeOf(r);
      if (!(g && g.ok && /^\d{8}$/.test(r.sbd || ""))) return;
      if (scores[r.sbd] != null) dup.push(r.sbd);
      scores[r.sbd] = g.total;
      const iss = issuesOf(r);
      if (iss.length) notes[r.sbd] = iss.join("; ");
    });
    if (!Object.keys(scores).length) throw new Error("Chưa có phiếu nào chấm được (cần SBD đủ 8 số + đáp án đúng mã đề).");
    if (dup.length) throw new Error(`Trùng SBD ${[...new Set(dup)].join(", ")} — sửa lại trước khi đẩy điểm.`);
    const skipped = rows.length - Object.keys(scores).length;
    if (!window.confirm(`Ghi ${Object.keys(scores).length} điểm vào kỳ thi (ghi đè điểm cũ của các SBD này)?${skipped ? `\n${skipped} phiếu bỏ qua (SBD chưa rõ / không chấm được) — nhập tay sau.` : ""}`)) return "Đã huỷ.";
    const r = await saveScoresBySbdThiKhaoSat(schoolId, ksId, { subjectKey: ksSubj, scores, notes });
    // Lưu bài làm (đáp án HS tô) + ảnh từng phiếu -> bấm đúp ô điểm ở Thi khảo sát để xem.
    const good = rows.filter((x) => scores[x.sbd] != null && !(r.missing || []).includes(x.sbd));
    const sheets = Object.fromEntries(good.map((x) => [x.sbd, { maDe: x.maDe, part1: x.part1, part2: x.part2, part3: x.part3, warnings: issuesOf(x), sourceFile: x.file, page: x.page }]));
    await saveSheetsThiKhaoSat(schoolId, ksId, { subjectKey: ksSubj, sheets });
    let imgOk = 0; const imgErr = [];
    for (let i = 0; i < good.length; i++) {
      const x = good[i];
      setKsMsg({ ok: `Đang lưu ảnh bài làm ${i + 1}/${good.length}...`, err: "" });
      try {
        const blob = await scanBatchPageImage(x.batchId, x.page);
        await uploadThiKhaoSatFile(schoolId, ksId, { kind: "bailam", subjectKey: ksSubj, sbd: x.sbd }, new File([blob], `Bai_lam_${x.sbd}.jpg`, { type: "image/jpeg" }));
        imgOk += 1;
      } catch (e) { imgErr.push(x.sbd); }
    }
    return `Đã ghi ${r.saved} điểm, ${imgOk} ảnh bài làm${imgErr.length ? ` (lỗi ảnh: SBD ${imgErr.join(", ")} — file quét đã hết hạn 3 giờ thì đọc lại phiếu)` : ""}.${r.missing && r.missing.length ? ` Không có trong kỳ thi: SBD ${r.missing.join(", ")}.` : ""}${skipped ? ` Bỏ qua ${skipped} phiếu.` : ""}`;
  });

  const run = async () => {
    if (!files.length) return;
    setRunning(true);
    setError("");
    setRows([]);
    stopRef.current = false;
    clearBatches();
    const out = [];
    try {
      // B1: tải từng file lên, lấy số trang
      const batches = [];
      for (let i = 0; i < files.length; i++) {
        setProgress({ done: 0, total: 0, label: `Đang tải lên ${files[i].name} (${i + 1}/${files.length})...` });
        const b = await uploadScanBatch(files[i]);
        batchIdsRef.current.push(b.batchId);
        batches.push({ ...b, name: files[i].name });
      }
      const total = batches.reduce((s, b) => s + b.pages, 0);
      let done = 0;
      // B2: đọc từng trang
      for (const b of batches) {
        for (let p = 1; p <= b.pages; p++) {
          if (stopRef.current) break;
          setProgress({ done, total, label: `${b.name} — trang ${p}/${b.pages}` });
          let r;
          try {
            r = await scanBatchPage(b.batchId, p);
          } catch (e) {
            r = { ok: false, page: p, message: e.message };
          }
          out.push({ file: b.name, ...r, page: p, batchId: b.batchId });
          done += 1;
          setRows([...out]);
        }
      }
      setProgress({ done, total, label: stopRef.current ? "Đã dừng." : "Xong." });
    } catch (e) {
      setError(e.message);
    } finally {
      setRunning(false);
    }
  };

  // Cảnh báo trùng SBD trong các phiếu đã đọc
  const sbdCount = {};
  rows.forEach((r) => { if (r.ok && r.sbd) sbdCount[r.sbd] = (sbdCount[r.sbd] || 0) + 1; });
  const issuesOf = (r) => {
    if (!r.ok) return [r.message || "Không đọc được trang này"];
    const w = [...(r.warnings || [])];
    if (!r.sbd || /[_?*]/.test(r.sbd)) w.unshift("SBD chưa rõ");
    if (!r.maDe || /[_?*]/.test(r.maDe)) w.unshift("Mã đề chưa rõ");
    if (r.sbd && sbdCount[r.sbd] > 1) w.unshift(`Trùng SBD ${r.sbd}`);
    const g = gradeOf(r);
    if (g && !g.ok) w.unshift(g.reason);
    const key = keys && keys[r.maDe];
    if (key) {
      // Phần II: tô "Đúng" toàn bộ / bỏ trống 1 vài ý — dễ là tô nhầm, nên xem lại phiếu
      const qs = key.p2.map((k, q) => (k && Object.values(k).some((x) => x != null) ? q : -1)).filter((q) => q >= 0);
      const p2 = r.part2 || [];
      if (qs.length && qs.every((q) => ["a", "b", "c", "d"].every((x) => (p2[q] || {})[x] === true))) w.push(`Phần II: tô "Đúng" cả ${qs.length * 4} ý`);
      qs.forEach((q) => { const b = ["a", "b", "c", "d"].filter((x) => (p2[q] || {})[x] == null); if (b.length && b.length < 4) w.push(`Phần II câu ${q + 1} ý ${b.join(",")} để trống`); });
    }
    return w;
  };
  const nWarn = rows.filter((r) => issuesOf(r).length).length;
  const shown = onlyWarn ? rows.filter((r) => issuesOf(r).length) : rows;

  const exportExcel = () => {
    if (!SCAN_EXCEL_EXPORT) return;
    const header = ["STT", "File", "Trang", "SBD", "Mã đề"];
    for (let i = 1; i <= 40; i++) header.push(`I.${i}`);
    for (let i = 1; i <= 8; i++) ["a", "b", "c", "d"].forEach((k) => header.push(`II.${i}${k}`));
    for (let i = 1; i <= 6; i++) header.push(`III.${i}`);
    if (keys) header.push("Điểm I", "Điểm II", "Điểm III", "Tổng điểm", "Câu sai");
    header.push("Cần kiểm tra");
    const data = rows.map((r, idx) => {
      const line = [idx + 1, r.file, r.page, r.ok ? r.sbd || "" : "", r.ok ? r.maDe || "" : ""];
      for (let i = 0; i < 40; i++) { const v = r.ok ? (r.part1 || [])[i] : null; line.push(v == null ? "" : v === "multi" ? "*" : v); }
      for (let i = 0; i < 8; i++) ["a", "b", "c", "d"].forEach((k) => { const q = r.ok ? (r.part2 || [])[i] : null; const v = q ? q[k] : null; line.push(v == null ? "" : ds(v)); });
      for (let i = 0; i < 6; i++) { const v = r.ok ? (r.part3 || [])[i] : null; line.push(v == null ? "" : v); }
      if (keys) {
        const g = gradeOf(r);
        if (g && g.ok) line.push(g.diem1, g.diem2, g.diem3, g.total, g.wrong.join(" "));
        else line.push("", "", "", "", "");
      }
      line.push(issuesOf(r).join("; "));
      return line;
    });
    const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
    ws["!cols"] = header.map((h, i) => ({ wch: i === 1 ? 22 : i === header.length - 1 ? 45 : i < 5 ? 10 : 6 }));
    ws["!freeze"] = { xSplit: 5, ySplit: 1 };
    const wb = XLSX.utils.book_new();
    if (keys) {
      // Sheet "Bang diem": gọn, sắp theo SBD — để dán vào danh sách điểm
      const pts = rows
        .map((r) => ({ r, g: gradeOf(r) }))
        .sort((a, b) => String(a.r.sbd || "").localeCompare(String(b.r.sbd || "")));
      const aoa = [["STT", "SBD", "Mã đề", "Điểm I", "Điểm II", "Điểm III", "Tổng điểm", "File", "Trang", "Ghi chú"]];
      pts.forEach(({ r, g }, i) =>
        aoa.push([i + 1, r.ok ? r.sbd : "", r.ok ? r.maDe : "", g && g.ok ? g.diem1 : "", g && g.ok ? g.diem2 : "",
          g && g.ok ? g.diem3 : "", g && g.ok ? g.total : "", r.file, r.page, issuesOf(r).join("; ")]));
      const ws2 = XLSX.utils.aoa_to_sheet(aoa);
      ws2["!cols"] = [6, 12, 8, 8, 8, 8, 10, 22, 6, 50].map((wch) => ({ wch }));
      XLSX.utils.book_append_sheet(wb, ws2, "Bang diem");
    }
    XLSX.utils.book_append_sheet(wb, ws, "Bai lam");
    const base = files.length === 1 ? files[0].name.replace(/\.[^.]+$/, "") : "nhieu-phong";
    downloadWorkbook(wb, `bai-lam-${base}.xlsx`);
  };

  const th = { padding: "6px 8px", borderBottom: "2px solid #d1d5db", textAlign: "left", background: "#f3f4f6", position: "sticky", top: 0, whiteSpace: "nowrap" };
  const td = { padding: "5px 8px", borderBottom: "1px solid #e5e7eb", verticalAlign: "top" };
  const mono = { ...td, fontFamily: "ui-monospace, Menlo, Consolas, monospace", fontSize: 13 };
  const pct = progress.total ? Math.round((progress.done / progress.total) * 100) : 0;

  return (
    <div style={{ maxWidth: 1400, margin: "0 auto", padding: 16 }}>
      <div style={{ marginBottom: 8 }}><Link to="/quiz3">← Quiz3</Link></div>
      <h2 style={{ margin: "0 0 6px 0" }}>Chấm cả phòng — phiếu THPT 3 phần</h2>
      <p style={{ color: "#4b5563", margin: "0 0 14px 0", fontSize: 14 }}>
        Chọn file PDF scan phiếu trả lời (mỗi trang 1 phiếu, có thể chọn nhiều file — mỗi phòng 1 file). Máy đọc SBD, mã đề
        và bài tô Phần I / II / III; dòng tô đậm vàng là phiếu cần xem lại (tô mờ, tô 2 ô, thiếu SBD...). Không cần căn chỉnh
        mẫu: máy tự dò theo các ô vuông đen trên phiếu.
      </p>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
        <input type="file" accept=".pdf,image/*" multiple disabled={running}
          onChange={(e) => { setFiles(Array.from(e.target.files || [])); setRows([]); setProgress({ done: 0, total: 0, label: "" }); }} />
        <label style={{ fontSize: 14, border: "1px dashed #9ca3af", borderRadius: 6, padding: "5px 8px" }}>
          Đáp án (Excel, tuỳ chọn):{" "}
          <input type="file" accept=".xlsx,.xls" onChange={(e) => loadKey((e.target.files || [])[0])} />
        </label>
        <button onClick={run} disabled={running || !files.length}
          style={{ padding: "8px 16px", background: "#2563eb", color: "#fff", border: 0, borderRadius: 6, cursor: "pointer", opacity: running || !files.length ? 0.5 : 1 }}>
          Đọc phiếu
        </button>
        {running && <button onClick={() => { stopRef.current = true; }} style={{ padding: "8px 14px" }}>Dừng</button>}
        {SCAN_EXCEL_EXPORT && <button onClick={exportExcel} disabled={running || !rows.length} style={{ padding: "8px 14px" }}>⬇ Xuất Excel</button>}
        <label style={{ fontSize: 14 }}>
          <input type="checkbox" checked={onlyWarn} onChange={(e) => setOnlyWarn(e.target.checked)} /> Chỉ hiện phiếu cần xem lại
        </label>
      </div>

      {(running || progress.label) && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ height: 10, background: "#e5e7eb", borderRadius: 5, overflow: "hidden" }}>
            <div style={{ width: `${pct}%`, height: "100%", background: "#16a34a", transition: "width .3s" }} />
          </div>
          <div style={{ fontSize: 13, color: "#374151", marginTop: 4 }}>
            {progress.total ? `${progress.done}/${progress.total} phiếu — ` : ""}{progress.label}
          </div>
        </div>
      )}
      {keyName && <div style={{ color: "#15803d", fontSize: 14, marginBottom: 8 }}>✓ Đáp án: {keyName} — điểm tính theo thang Bộ 2025 (I: 0,25/câu; II: 0,1/0,25/0,5/1 theo số ý đúng; III: 0,5/câu).</div>}
      {keyError && <div style={{ color: "#b91c1c", fontSize: 14, marginBottom: 8 }}>Đáp án: {keyError}</div>}
      {canHs && ksList.length > 0 && (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", fontSize: 14, border: "1px solid #e5e7eb", background: "#f9fafb", borderRadius: 6, padding: "8px 10px", marginBottom: 10 }}>
          <b>Kỳ thi khảo sát:</b>
          <select value={ksId} onChange={(e) => setKsId(e.target.value)} disabled={ksBusy}>
            {ksList.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
          </select>
          <select value={ksSubj} onChange={(e) => setKsSubj(e.target.value)} disabled={ksBusy}>
            {(ksExam ? ksExam.subjects : [{ key: "toan", label: "Toán" }]).map((x) => <option key={x.key} value={x.key}>{x.label}</option>)}
          </select>
          {savedKey
            ? <button onClick={useSavedKey} disabled={ksBusy}>Dùng đáp án đã lưu ({savedKey.fileName || "?"}, {Object.keys(savedKey.keys || {}).length} mã đề)</button>
            : ksExam && <span style={{ color: "#6b7280" }}>Môn này chưa lưu đáp án.</span>}
          <button onClick={saveKeyToExam} disabled={ksBusy || !keys || !ksId}>⬆ Lưu đáp án lên kỳ thi</button>
          <button onClick={pushScores} disabled={ksBusy || running || !keys || !rows.length || !ksId}
            style={{ background: "#16a34a", color: "#fff", border: 0, borderRadius: 4, padding: "4px 10px", opacity: ksBusy || running || !keys || !rows.length ? 0.5 : 1 }}>
            ⬆ Đẩy điểm vào kỳ thi (theo SBD)
          </button>
          {ksMsg.ok && <span style={{ color: "#15803d" }}>{ksMsg.ok}</span>}
          {ksMsg.err && <span style={{ color: "#b91c1c" }}>{ksMsg.err}</span>}
        </div>
      )}
      {error && <div style={{ color: "#b91c1c", marginBottom: 12 }}>{error}</div>}

      {rows.length > 0 && (
        <>
          <div style={{ fontSize: 14, marginBottom: 6 }}>
            Đã đọc <b>{rows.length}</b> phiếu — <b style={{ color: nWarn ? "#b45309" : "#15803d" }}>{nWarn}</b> phiếu cần xem lại.
          </div>
          <div style={{ overflow: "auto", maxHeight: "70vh", border: "1px solid #e5e7eb", borderRadius: 6 }}>
            <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 14 }}>
              <thead>
                <tr>
                  <th style={th}>#</th><th style={th}>File / trang</th><th style={th}>SBD</th><th style={th}>Mã đề</th>
                  <th style={th}>Phần I</th><th style={th}>Phần II</th><th style={th}>Phần III</th>{keys && <th style={th}>Điểm</th>}<th style={th}>Cần kiểm tra</th>
                </tr>
              </thead>
              <tbody>
                {shown.map((r) => {
                  const iss = issuesOf(r);
                  return (
                    <tr key={`${r.file}-${r.page}`} style={{ background: iss.length ? "#fef3c7" : undefined }}>
                      <td style={td}>{rows.indexOf(r) + 1}</td>
                      <td style={{ ...td, whiteSpace: "nowrap" }}>{r.file}<br /><span style={{ color: "#6b7280" }}>trang {r.page}</span></td>
                      <td style={{ ...mono, fontWeight: 600 }}>{r.ok ? r.sbd : ""}</td>
                      <td style={{ ...mono, fontWeight: 600 }}>{r.ok ? r.maDe : ""}</td>
                      <td style={mono}>{r.ok ? fmtP1(r.part1) : ""}</td>
                      <td style={mono}>{r.ok ? fmtP2(r.part2) : ""}</td>
                      <td style={mono}>{r.ok ? fmtP3(r.part3) : ""}</td>
                      {keys && (() => {
                        const g = gradeOf(r);
                        return (
                          <td style={{ ...td, whiteSpace: "nowrap" }}>
                            {g && g.ok ? (
                              <span title={g.wrong.length ? `Sai: ${g.wrong.join(" ")}` : "Đúng hết"}>
                                <b style={{ fontSize: 15 }}>{g.total.toFixed(2)}</b>
                                <br /><span style={{ fontSize: 12, color: "#6b7280" }}>{g.diem1} + {g.diem2} + {g.diem3}</span>
                              </span>
                            ) : ""}
                          </td>
                        );
                      })()}
                      <td style={{ ...td, color: "#b45309", fontSize: 13 }}>{iss.join("; ")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>
            Ký hiệu: · = không tô, * = tô nhiều ô; Phần II: Đ/S theo ý a b c d.
          </div>
        </>
      )}
    </div>
  );
};

export default Quiz3ScanBatch;
